import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const ProgramList = Loadable(
  lazy(() => import("features/program/components/List"))
);
const ProgramPage = Loadable(
  lazy(() => import("features/program/components/Page"))
);
const routes = {
  path: "program",
  children: [
    { path: "", element: <ProgramList /> },
    { path: "add", element: <ProgramPage /> },
    { path: "edit/:programID?", element: <ProgramPage /> },
  ],
};

export default routes;
